import { client, handleRequestBody } from "./client.ts";

export interface LoginRequest {
	email: string;
	password: string;
}

export interface LoginAccount {
	id: string;
	name: string;
}

export interface LoginResponse {
	jwt: string;
	accounts: LoginAccount[];
}

export function login(req: LoginRequest): Promise<LoginResponse> {
	return handleRequestBody(() => client.post<LoginResponse>("/login", req));
}
